import { FormSection as Section } from "$components/form-section";
import { TextField } from "$components/rhf-fields";
import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";
import {
  PhoneOwnershipRadioInput,
  PhoneOwnershipRadioOptions,
} from "$routes/new/patient/_lib/sections/phone-ownership";
import React from "react";
import { useWatch } from "react-hook-form";
import { useIntl } from "react-intl";

const RHFHideIf: FCwC<{
  name: string;
  condition: (value: unknown) => boolean;
}> = ({ name, condition, children }) => {
  const valueOfField = useWatch({ name });
  return condition(valueOfField) ? null : <>{children}</>;
};

const PhoneNumberInput: FC<React.ComponentProps<typeof TextField>> = (
  delegateProps,
) => {
  const { formatMessage } = useIntl();
  return (
    <TextField
      id="phone-number"
      type="tel"
      label={formatMessage({
        id: "patient.contactSection.phoneNumber.label",
        defaultMessage: "Phone Number",
      })}
      data-testid="phoneNumber"
      {...delegateProps}
    />
  );
};

export const ContactSection: FC<{
  required?: boolean;
  fieldNames: { phoneNumber: string; phoneOwnership: string; email: string };
}> = ({ required, fieldNames }) => {
  const { formatMessage } = useIntl();
  const [captureEmailFlag] = useFeatureFlag(featureFlags.capturePatientEmail);

  return (
    <Section
      title={formatMessage({
        id: "patient.contactSection.heading",
        defaultMessage: "Contact Details",
      })}
    >
      {captureEmailFlag && (
        <TextField
          fullWidth
          name={fieldNames.email}
          label={formatMessage({
            id: "patient.generalSection.email.label",
            defaultMessage: "Email",
          })}
          placeholder="Email"
          type="email"
        />
      )}
      <PhoneOwnershipRadioInput
        required={required}
        fullWidth
        name={fieldNames.phoneOwnership}
      />
      <RHFHideIf
        name={fieldNames.phoneOwnership}
        condition={(value) => value === PhoneOwnershipRadioOptions.None}
      >
        <PhoneNumberInput
          required={required}
          fullWidth
          name={fieldNames.phoneNumber}
        />
      </RHFHideIf>
    </Section>
  );
};
